import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { config } from '@app/app.config';
import { AuthResponse } from '../../../interfaces/http';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  passwordReset = false;
  form: any = new FormGroup({
    email: new FormControl('')
  });

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  submitForgotPassword() {
    const payload = {
      email: this.form.value.email,
      returnURL: window.location.origin + '/auth/reset-password'
    };
    this.http
      .post(config.httpURL + '/api/forgot-password', null, { params: payload })
      .subscribe((response: AuthResponse) => {
        console.log(response);
        this.passwordReset = true;
      });
  }
}
